<template lang="pug">
div
  EnterpriseSelector(@select="select")
  v-divider
  .s-vstack
    EnterpriseRegion
</template>

<script>
import EnterpriseRegion from "/libs/components/Enterprise/Region";
import { EventBus } from "@/event-bus";

export default {
  components: { EnterpriseRegion },
  computed: {
    enterprise() {
      return this.$store.getters["entp/enterprise"];
    },
  },
  mounted() {
    this.$store.dispatch("entp/setEnterprise");
    EventBus.$emit("enterprise:changed");
  },
  methods: {
    select(enterprise) {
      this.$store.dispatch("entp/setEnterprise", enterprise);
      EventBus.$emit("enterprise:changed");
    },
  },
};
</script>